import { Center, Image, Spinner, Text, VStack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { NotFound } from "@src/components/widgets/ErrorPage";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { API_BASE_URL } from "@src/config/constants";
import { createFileRoute } from "@tanstack/react-router";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

type AcceptEmailDeliveryProps = {
  logo: string | undefined | null;
  invoice_no: string | undefined | null;
} | null;

async function fetchClient(
  publicId: string,
): Promise<AcceptEmailDeliveryProps | null> {
  let client: AcceptEmailDeliveryProps = null;

  try {
    const res = await fetch(
      `${API_BASE_URL}/email-accept-delivery?public_id=${publicId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    client = await res.json();
  } catch (e) {
    console.error(e);
  }

  return client;
}

const Page = () => {
  const { query, isReady } = useRouter();
  const [fetching, setFetching] = useState(true);
  const [client, setClient] = useState<AcceptEmailDeliveryProps | null>(null);

  useEffect(() => {
    if (!isReady) return;
    if (!query) return;
    if (!query.public_id) return;
    handleFetchClient(
      Array.isArray(query.public_id) ? query.public_id[0] : query.public_id,
    );
  }, [query, isReady]);

  const handleFetchClient = async (publicId: string) => {
    const client = await fetchClient(publicId);
    setFetching(false);
    setClient(client);
  };

  if (fetching) {
    return (
      <>
        <NoIndexHead />
        <Center w="100vw" h="100vh">
          <Spinner size="lg" />
        </Center>
      </>
    );
  }

  if (!client) {
    return (
      <>
        <NoIndexHead />
        <NotFound />
      </>
    );
  }

  return (
    <>
      <NoIndexHead />
      <VStack align="center" w="full" pt="20%" spacing="8">
        {client.logo && <Image alt={t`Client logo`} src={client.logo} />}
        <Text textAlign="center">
          <Trans>
            Thank you, for accepting delivery of Invoice&nbsp;
            {client.invoice_no}
          </Trans>
        </Text>
        <Text textAlign="center">
          <Trans>Now, you can safely close this page.</Trans>
        </Text>
      </VStack>
    </>
  );
};

export const Route = createFileRoute("/accept_email_delivery/")({
  component: Page,
});
